// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__bnwBI","input":"Input_input__1OJBC","label":"Input_label__ZxZd1","error":"Input_error__1SkMh"};